import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { change, logout, profileimg, user } from "../Constant/Index";
import { LOGOUT_SUCCESS, ROLE, USER_PROFILE } from "../redux/Slices/AuthSlice";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { profileupdateimage } from "../network/Network";

const PhysicianProfileSidebar = () => {
	// Initialize with a default image or placeholder
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const token = useSelector((state) => state?.Auth?.token);
	const userprofie = useSelector((state) => state?.Auth?.userprofie);
	const myrole = useSelector((state) => state?.Auth?.role);
	const userDetail = useSelector((state) => state?.Auth?.users);
	const [profileImage, setProfileImage] = useState(profileimg);
	const [userImage, setUserImage] = useState("");
	const [newFile, setNewFile] = useState("");
	const [fileupload, setFileupload] = useState("");
	const [uploadLoading, setUploadLoading] = useState(false);
	let currentUrl = window.location.href.split("/");
	const [loading, setLoading] = useState(false);

	// Image Upload Handler
	const handleImageUpload = (e) => {
		e.preventDefault();
		const reader = new FileReader();
		const file = e.target.files[0];
		reader.onloadend = () => {
			setNewFile(file);
			setFileupload(reader.result);
		};
		reader.readAsDataURL(file);
		setUploadLoading(true);
	};
	// ============

	// Update Profile Image Handler
	const profileImagehandler = (e) => {
		e.preventDefault();
		setLoading(true);

		if (!newFile) {
			Swal.fire({
				position: "center",
				icon: "error",
				text: "Select Image First",
				showConfirmButton: false,
				timer: 1500,
			});
		}

		let data = {
			image: newFile,
		};
		profileupdateimage(myrole, data, token)
			.then((res) => {
				dispatch(USER_PROFILE(res?.data?.image_url));
				setUserImage(res?.data?.image_url);
				Swal.fire({
					position: "center",
					icon: "success",
					text: "Profile Image Uploaded",
					showConfirmButton: false,
					timer: 1500,
				});
				navigate("/physician-personal-info");
				setNewFile("");
				setFileupload("");
				setLoading(false);
			})
			.catch((err) => {
				setLoading(false);
			});
	};

	//   Logut Handler
	const LogoutHandler = (e) => {
		e.preventDefault();
		dispatch(LOGOUT_SUCCESS());
		dispatch(USER_PROFILE());
		dispatch(ROLE());

		navigate("/sign-in");
	};
	//   ===============
	return (
		<>
			<div className="sidebar physician">
				<div className="profile-upload d-flex align-items-center justify-content-between p-3 border radius-20 mb-2">
					<div className="main-class d-flex align-items-center gap-2">
						<div className="upload-img-wrapper position-relative">
							{!userprofie ? (
								<>
									<img
										id="profile-img"
										src={
											fileupload ? fileupload : userDetail?.profile_image_url
										}
										className="img-fluid"
										alt="Profile"
									/>
								</>
							) : (
								<img
									id="profile-img"
									src={fileupload ? fileupload : userprofie}
									className="img-fluid"
									alt="Profile"
								/>
							)}
							{currentUrl[3] == "physician-profile-edit" ? (
								<>
									<div className="position-absolute bottom-0 right-0 wrapper-positiomas">
										<label htmlFor="file-upload" className="plus-icon-profile">
											<i className="fa-solid fa-plus"></i>
										</label>
										<input
											type="file"
											id="file-upload"
											accept="image/*"
											style={{ display: "none" }}
											onChange={handleImageUpload}
										/>
									</div>
								</>
							) : null}
						</div>
						<div className="profile-name">
							<h5 className="main-heading level-7 mb-0 main-heading-font dark-color">
								{userDetail?.first_name}
							</h5>
							<h6 className="level-9 mb-0 primary-medium-font extra-color-12">
								{userDetail?.email}
							</h6>
						</div>
						{currentUrl[3] == "physician-profile-edit" ? (
							<>
								<div
									style={{
										position: "absolute",
										right: "11px",
									}}
									className="edit-btn "
								>
									<label
										htmlFor="file-upload"
										className="nav-anchor loading-btn loading"
									>
										<i
											onClick={(e) => profileImagehandler(e)}
											className={loading ? "fa fa-spinner" : "fa fa-check"}
											aria-hidden="true"
										></i>
									</label>
								</div>
							</>
						) : null}
					</div>
				</div>
				<div className="general-nav p-3 border radius-20 mb-2">
					<h5 className="main-heading level-6 main-heading-font dark-color">
						General
					</h5>
					<ul>
						<li className="">
							<NavLink
								to="/physician-personal-info"
								activeclassname="active"
								className="nav-sidebar d-flex align-items-center justify-content-between text-decoration-none"
							>
								<div className="main-class-list d-flex align-items-center gap-2">
									<img src={user} className="img-fluid" alt="Profile" />
									<div className="profile-name">
										<h5 className="main-heading level-7 mb-0 main-heading-font dark-color">
											Personal Info
											{/* Edit Profile */}
										</h5>
										<h6 className="level-9 mb-0 primary-medium-font extra-color-12">
											View profile picture, contact
										</h6>
									</div>
								</div>
								<div className="edit-btn">
									<div className="nav-anchor">
										<i className="fa-solid fa-arrow-right"></i>
									</div>
								</div>
							</NavLink>
						</li>
						<li className="mt-4">
							<NavLink
								to="/physician-password"
								activeclassname="active"
								className="nav-sidebar d-flex align-items-center justify-content-between text-decoration-none"
							>
								<div className="main-class-list d-flex align-items-center gap-2">
									<img src={change} className="img-fluid" alt="Profile" />
									<div className="profile-name">
										<h5 className="main-heading level-7 mb-0 main-heading-font dark-color">
											Change Password
										</h5>
										<h6 className="level-9 mb-0 primary-medium-font extra-color-12">
											Update and strengthen account security
										</h6>
									</div>
								</div>
								<div className="edit-btn">
									<div className="nav-anchor">
										<i className="fa-solid fa-arrow-right"></i>
									</div>
								</div>
							</NavLink>
						</li>
						<li className="mt-4">
							<NavLink
								to="/physician-time"
								activeclassname="active"
								className="nav-sidebar d-flex align-items-center justify-content-between text-decoration-none"
							>
								<div className="main-class-list d-flex align-items-center gap-2">
									<img src={change} className="img-fluid" alt="Profile" />
									<div className="profile-name">
										<h5 className="main-heading level-7 mb-0 main-heading-font dark-color">
											Add Your Availability
										</h5>
										<h6 className="level-9 mb-0 primary-medium-font extra-color-12">
											Which time you availaible
										</h6>
									</div>
								</div>
								<div className="edit-btn">
									<div className="nav-anchor">
										<i className="fa-solid fa-arrow-right"></i>
									</div>
								</div>
							</NavLink>
						</li>
						<li className="mt-4">
							<NavLink
								to="/physician-myconsultations"
								activeclassname="active"
								className="nav-sidebar d-flex align-items-center justify-content-between text-decoration-none"
							>
								<div className="main-class-list d-flex align-items-center gap-2">
									<img src={change} className="img-fluid" alt="Profile" />
									<div className="profile-name">
										<h5 className="main-heading level-7 mb-0 main-heading-font dark-color">
											My Consultations
										</h5>
										<h6 className="level-9 mb-0 primary-medium-font extra-color-12">
											View Upcoming and Past Consultations
										</h6>
									</div>
								</div>
								<div className="edit-btn">
									<div className="nav-anchor">
										<i className="fa-solid fa-arrow-right"></i>
									</div>
								</div>
							</NavLink>
						</li>
					</ul>
				</div>
				<div className="login p-3 border radius-20 mb-2">
					<Link
						to=""
						className="nav-sidebar d-flex align-items-center justify-content-between text-decoration-none"
					>
						<div className="main-class-list d-flex align-items-center gap-2">
							<img src={logout} className="img-fluid" alt="Profile" />
							<div className="profile-name">
								<h5 className="main-heading level-7 mb-0 main-heading-font extra-color-11">
									Logout
								</h5>
								<h6 className="level-9 mb-0 primary-medium-font extra-color-12">
									Securely logout of account
								</h6>
							</div>
						</div>
						<div onClick={(e) => LogoutHandler(e)} className="edit-btn">
							<div className="nav-anchor">
								<i className="fa-solid fa-arrow-right"></i>
							</div>
						</div>
					</Link>
				</div>
			</div>
		</>
	);
};

export default PhysicianProfileSidebar;
